import { useMutation } from '@tanstack/react-query';
import ForbiddenError from 'api/errors/ForbiddenError';
import postTokenBasicApiCall, {
  PostTokenBasicPayload,
  PostTokenBasicResponse,
} from 'api/calls/postTokenBasicApiCall';
import UnauthorizedError from 'api/errors/UnauthorizedError';

const useBasicTokenMutation = () => {
  return useMutation<
    PostTokenBasicResponse,
    UnauthorizedError | ForbiddenError | Error,
    PostTokenBasicPayload
  >(postTokenBasicApiCall);
};

export default useBasicTokenMutation;
